<template>
  <div class="protocol">
    <header>
      <h1 class="title">乐享瘦减重服务协议</h1>
    </header>
    <main>
      <p>在您（以下或称“甲方”）开始使用和购买乐享瘦减重服务之前，请您仔细阅读并充分理解《乐享瘦减脂服务协议》(以下简称”本协议”)。
您确认，您具备中华人民共和国法律规定的与您行为相适应的民事行为能力，确保有能力对您购买乐享瘦减重服务的一切行为独立承担责任。若您不具备签署与您行为相适应的民事行为能力，请在您的监护人陪同下阅读本协议，并在取得他们对您使用服务的行为以及对本协议全部条款的同意之后，方可使用本服务。乐享瘦减重服务方（以下称“我们”或“乙方”）在依据法律规定或本协议约定要求您承担责任时，有权向您的监护人追偿。</p>
      <p>如果您对本协议的任何条款表示异议，或者无法准确理解本协议，请不要接受乐享瘦减脂服务。您通过网络页面点击确认、通过第三方软件（包括但不限于微信、小程序或QQ等）授权登录或其他方式选择接受本协议以及您的购买、访问、使用本服务等行为视为对本协议全部内容的接受，也意味您将接受本协议以及未来针对本协议更新版本条款的约束，并服从乐享瘦减重服务的统一管理。</p>
      <p>本协议是您（以下简称“用户”）与广州乐享瘦健康咨询有限公司之间关于您购买和接受乐享瘦远程线上减重服务所订立的协议，本协议仅用于您购买乐享瘦远程线上减重服务，若您购买的非乐享瘦远程线上减重服务，不适用本协议内容。</p>
      <p>一、服务购买</p>
      <p>1、在您购买乐享瘦远程线上减重服务（具体以购买页面展示为准）之前，您应已经阅读、理解并确认接受本协议的全部内容。您确认在已知悉并确认接受本协议的前提下支付服务费用。</p>
      <p>2、通过您账号购买乐享瘦减重服务的行为视为您本人的真实意思，本协议自乐享瘦减重服务方收到您支付的服务费用起生效。</p>
      <p>3、您支付的费用包括您在减重服务期间的营养师全周期跟踪、监督、咨询服务费、减重方案制定服务费。您应在本协议签订时向乙方支付上述服务费用。</p>
      <p>二、您的权利和义务</p>
      <p>1、您参加减重服务时必须充分了解减重服务模式以及服务计划，并确认自身身体健康状况完全适合参加减重服务项目。您应就其健康状况向乙方进行充分说明，如您已怀孕或在服务期怀孕；患有甲状腺疾病、脑梗、冠心病、严重肝肾疾病、食物过敏、精神类疾病（心理障碍、抑郁症、焦虑症、双向情感障碍）等需要药物控制的慢性疾病；或存在一年内有抽脂、一年内有切胃、半年内服用过激素药物的；或心脏病、心脑血管系统疾病、严重肝肾疾病等需要特殊照顾、肢体残疾的、运动训练的疾病或有关病史的，您应向我们全面和真实地披露，以便于我们决定是否接受您进行减重服务或向您提供所需的特殊方案服务。如您未及时告知或故意隐瞒的，由此导致的一切后果由您自行承担：因您未及时告知或故意隐瞒疾病或病史的，致使其在正常服务开始后无法正常参加减重服务或入减重服务后经我们查明您身体状况不适合参加减重服务项目的，我们有权单方面解除本协议，且无需向您退还您已支付的减重服务项目费用。</p>
      <p>2、您在减重服务期间，须配合我们的服务管理工作并按要求执行我们为您制定的相关减重方案。</p>
      <p>3、您在减重服务期间，应向我们提供每天的三餐饮食记录，饮食记录以您的早餐、午餐、晚餐的完整餐食拍照上传为依据，您的饮食需要按照我们为您提供的饮食方案执行，若您出现饮食方案计划外的特殊加餐等情况，应向我们全面和真实的反馈。</p>
      <p>4、减重服务开通后，服务期内由于您方面的原因需暂停减重服务的，将根据您购买的周期数(1周期=28天自然日)，享有不同的暂停天数，如2周期服务可暂停1次，3周期服务可暂停2次，以此类推，单次暂停不超过10天。</p>
      <p>5、本协议有效期间，您须配合我们的服务管理工作并执行我们所制定的减重方案以确保您的减重的安全和有效。</p>
      <p>6、若因您单方面要求解除协议的，退款规则为：所缴纳金额-平台扣取费用-已服务天数×服务单价-营养方案费用。（注：平台扣取费用包括但不限于：支付平台向乙方收取的手续费，花呗或信用卡等支付方式产生的手续费等；营养方案费用依据中国营养学会团体标准T/CNSS 033—2024“营养保健服务项目和价值参考”制定，1人/次收费500元人民币。）</p>
      <p>您申请退费时，应向乙方提供本人个人信息和收款信息，包括但不限于：收款人姓名、收款人身份证号码、收款人本人银行卡账号/支付宝号等，并与乙方签署退费协议。</p>
      <p>三、乙方的权利和义务</p>
      <p>1.乙方有义务在您开始减重服务前向您充分说明减重服务的基本情况以及减重方案,包括减重服务期间注意事项等。</p>
      <p>2.乙方有权制定减重服务相关管理规定。如您发生因不遵守乙方制定的减重服务相关管理规定或其他非因乙方原因而造成的疾病、伤害等事故，乙方不承担任何赔偿责任。</p>
      <p>四、知识产权和保密约定</p>
      <p>经由乙方传送的文字、图片、音频、视频及其他内容，受到著作权法、商标法、专利法或其他法律的保护，您有保密义务；未经乙方书面授权许可，您不得自行或许可第三方进行复制、转载、传播、修改、售卖、衍生其他作品或者从事其他侵犯乙方知识产权的行为。您不得以任何形式在互联网平台传播乙方发送的文字、图片（包括但不限于聊天记录和服务方案等）。您不得以任何形式，有偿或无偿使得第三方获得内容的全部或部分内容。若您违反协议知识产权和保密约定的，您将承担赔偿责任，乙方为维护权益而合理支出的费用（包括但不限于诉讼费、公证费、鉴定费、保全费、保全担保费、律师费等）由您承担。 </p>
      <p>五、协议有效期</p>
      <p>1.本协议自乙方收到您支付的服务费用起生效，有效期间至本协议约定的义务履行完毕之日，本协议有效期不超过12个月。如协议期满后，您要求延长本协议有效期的，双方须重新签订协议，但延长时长最多不超过12个月。</p>
      <p>2.经甲、乙双方协商一致,可以变更、解除或终止本协议。</p>
      <p>3.如因不可抗力因素（如地震、火灾等自然灾害、战争、政府行为等）导致本协议一方无法继续履行本协议，遭受不可抗力事件的一方应及时以书面方式通知另一方，并告知其该事件对本协议可能产生的影响，并应在合理期限内提供相关证明。双方经协商确认后可延长本协议的有效期，延长的有效期为受不可抗力影响的时长。</p>
      <p>六、相关事宜</p>
      <p>1.本协议一式二份，甲、乙双方各执一份，均具有同等的法律效力。</p>
      <p>2.您应确保其于本协议所列您所有信息包括但不限于通讯地址、电话真实有效，乙方根据上述信息发函、致电，即视为您已收悉，如您的通讯地址、电话变更的，应在变更当日书面告知乙方，否则由此产生的后果由您承担。</p>
      <p>3.甲乙双方承诺，本协议涵盖了之前双方口头和书面上依据客观实施达成的所有的一致意见，并且是在双方对彼此的关系有了全面的理解的基础上达成的，本协议与前述协商或书面文件如有不同的，均以本协议为准。本协议签字盖章和授权代表签字后即时生效。对于未尽事宜,经双方协商一致，可另行签订补充协议，补充协议与本协议具有同等法律效力，如有不一致之处，以双方后签署的补充协议为准。</p>
      <p>4.本协议签署、效力、解释和执行均应适用中华人民共和国法律。对于因本协议的解释及执行等产生的争议，双方通过友好协商解决。协商不成时，任何一方均可向乙方所在地有管辖权人民法院提起诉讼。</p>
      <p>（以下无正文）</p>
      <p>甲方（或其法定代理人）签字：       乙方（盖章）： </p>
      <p>日期：                             日期：</p>
    </main>
  </div>
</template>
<script>
export default {
  name: 'protocol_bbk',
  data() {
    return {
      payTime: this.$route.query.pt || '',
      payTimeStr: ''
    };
  },
  created() {
    if (this.payTime) {
      this.payTimeStr = `${this.payTime.substr(0, 4)}年${
        this.payTime.substr(4, 2)}月${
        this.payTime.substr(6, 2)}日`;
    }
  },
  methods: {}
};
</script>

<style lang="stylus" scoped>
.protocol {
  padding: 15px 20px;
  width: 100%;
}

.title {
  box-sizing: content-box;
  margin: 0;
  width: auto;
  font-size: 22.5pt;
  font-weight: 800;
  height: 60px;
  padding-top: 30px;
  border-bottom: 1px solid #e7e7e7;
  text-align: center;
}

.datetime {
  margin: 20px 0;
  text-align: right;
}

main {
  width: 100%;

  p {
    font-size: 16px;
    color: #191919;
    line-height: 32px;
    margin-top: 10px;
  }

  .bold-content {
    font-weight: bold;
  }

  h4 {
    padding: 30px 0 15px;
    font-size: 22px;
    font-weight: 900;
    line-height: 36px;
    color: #191919;
  }
}
</style>
